import { useState, useEffect } from 'react';
import { collection, query, where, orderBy, onSnapshot, limit } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useAuthContext } from '../context/AuthContext';

/**
 * Real-time listener for public open bouts (lobby).
 * Filters out bouts created by the current user client-side.
 */
export function usePublicLobby() {
  const { user } = useAuthContext();
  const [lobbyBouts, setLobbyBouts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(
      collection(db, 'bouts'),
      where('visibility', '==', 'public'),
      where('status', '==', 'open'),
      orderBy('createdAt', 'desc'),
      limit(20)
    );

    const unsub = onSnapshot(
      q,
      (snap) => {
        let results = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        // Filter out current user's own bouts client-side
        if (user) {
          results = results.filter((b) => b.createdBy !== user.uid);
        }
        setLobbyBouts(results);
        setLoading(false);
      },
      (err) => {
        console.error('Error listening to public lobby:', err);
        setLoading(false);
      }
    );

    return unsub;
  }, [user]);

  return { lobbyBouts, loading };
}
